module.exports = __webpack_public_path__ + "img/success-add.bbba0ad5.svg";